@import "~@uipath/apollo-core/src/scss/base-host.scss";

@import "../../utils/mixins/mixins.scss";

.portal-button {
  @include portal-button();
}

a.portal-button {
  height: auto;

  &.md {
    padding: $pad-l $pad-xl;
  }

  &.sm {
    padding: $pad-l $pad-xl;
  }
}

.contact-sales-button {
  background-color: transparent !important;
  border: 1px solid $color-border-dark !important;
  color: $color-foreground-de-emp-dark !important;
}
